import { render, staticRenderFns } from "./moreSchedule.vue?vue&type=template&id=2c594150&scoped=true"
import script from "./moreSchedule.vue?vue&type=script&lang=js"
export * from "./moreSchedule.vue?vue&type=script&lang=js"
import style0 from "./moreSchedule.vue?vue&type=style&index=0&id=2c594150&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c594150",
  null
  
)

export default component.exports